// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__16LH0","title":"AfterFrontImage_title__1XP3T"};